import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ImagesContainer } from 'ZalamoLibrary/src/lib/upload/graphql';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { PhotoGroupList } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { UntypedFormControl } from '@angular/forms';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { getPhotoGroupFromPhotoId } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/helpers';
import { WallPieceCropComponent } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/edit-wall-decor-piece/wall-piece-crop/wall-piece-crop.component';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
    selector: 'lib-look-book-album-image-editor',
    templateUrl: './look-book-album-image-editor.component.html',
    styleUrls: ['./look-book-album-image-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LookBookAlbumImageEditorComponent implements OnInit {
  @Input() context: ImagesContainer;
  @Input() contextId: ImagesContainer;
  @Input() availableImages: string[] = [];
  @Input() @Required current: string;
  @Input() @Required imageRelations: PhotoGroupList[] = [];
  @Output() picked = new EventEmitter<string>();
  @Output() cropped = new EventEmitter<{
    x: number;
    y: number;
    w: number;
    h: number;
  }>();
  @Input() ratio = 1;
  currentCrop = new UntypedFormControl();
  saved = new EventEmitter<{
    photoId: string;
    crop: {
      x: number;
      y: number;
      w: number;
      h: number;
    };
  }>();
  private _photoId;

  get photoId() {
    return this._photoId;
  }

  set photoId(value) {
    this._photoId = value;
  }

  constructor(private zalamoDialogService: ZalamoDialogService) {}

  ngOnInit(): void {}

  photoPicked(photoId) {
    const photoDetails = getPhotoGroupFromPhotoId(photoId, this.imageRelations);
    const imageRatio = photoDetails.width / photoDetails.height;
    if (this.ratio > imageRatio) {
      this.currentCrop.patchValue({
        w: 100,
        x: 0,
        h: (imageRatio / this.ratio) * 100,
        y: 100 - (imageRatio / this.ratio) * 100,
      });
    } else {
      this.currentCrop.patchValue({
        h: 100,
        y: 0,
        w: (this.ratio / imageRatio) * 100,
        x: 100 - (this.ratio / imageRatio) * 100,
      });
    }
    this.save();
  }

  startCrop(photoId) {
    console.log(this.imageRelations);
    const ref = this.zalamoDialogService.openRight(WallPieceCropComponent);
    ref.componentInstance.availableImages = this.availableImages;
    ref.componentInstance.context = this.context;
    ref.componentInstance.contextId = this.contextId;
    ref.componentInstance.imageRelations = this.imageRelations;
    ref.componentInstance.photoId = photoId;
    ref.componentInstance.containerRatio = this.ratio;
    const photoDetails = getPhotoGroupFromPhotoId(photoId, this.imageRelations);
    ref.componentInstance.imageRatio = photoDetails.width / photoDetails.height;
    ref.componentInstance.saved
      .pipe(
        takeUntil(ref.afterClosed()),
        tap((crop) => {
          this.currentCrop.patchValue(crop);
          this.cropped.emit({
            h: (crop.h / 100) * photoDetails.height,
            w: (crop.w / 100) * photoDetails.width,
            x: (crop.x / 100) * photoDetails.width,
            y: (crop.y / 100) * photoDetails.height,
          });
          ref.close();
        })
      )
      .subscribe();
  }

  save() {
    this.saved.next({ photoId: this._photoId, crop: this.currentCrop.value });
  }
}
